import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert } from "@mui/material";
import { LOGIN_API_OLIVS_APP_URL } from "../../utils/api";
import envConfig from "../../config";
import { setCrossDomainCookie } from "../../utils/cookie-utils";
import { getSafeRedirectUrl } from "../../utils/navigation-utils";

const SessionManagement = () => {
  const { sessionGuid } = useParams();

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url =
          LOGIN_API_OLIVS_APP_URL +
          `en-au/session-management/register-new-session-instance?BaseHostURL=${envConfig.loginUrl}`;

        const responseApiCall = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "olivs-api-real-ip": "127.0.0.2",
            "olivs-api-computer-name": "BTM-WS2019",

            "api-key": "OlivsAuth",
            "Content-Type": "application/json",
            "browser-agent": window.navigator.userAgent,
          },
          body: JSON.stringify({
            IpAddress: "127.0.0.2",
            UserAgentAkaBrowserDetails: navigator.userAgent,
            CurrentHost: window.location.origin,
            SessionGuid: sessionGuid,
          }),
        });

        const dataApiCall = await responseApiCall.json();
        if (
          !responseApiCall.ok ||
          !dataApiCall ||
          dataApiCall.successYN !== "Y"
        ) {
          if (
            dataApiCall?.errorMessage === "Session Guid has been expired" ||
            dataApiCall?.errorMessage === "Session Guid has been used before"
          ) {
            const savedReferrer = localStorage.getItem("savedReferrer");
            if (savedReferrer) {
              localStorage.removeItem("savedReferrer");
              window.location.href = getSafeRedirectUrl(
                savedReferrer,
                window.location.origin,
              );
              return;
            }
            setErrorMessage(dataApiCall?.errorMessage);
          }
        } else {
          localStorage.setItem(
            "savedReferrer",
            getSafeRedirectUrl(
              dataApiCall.referrerUrl,
              window.location.origin,
            ),
          );
          document.cookie = `loginEmail=${dataApiCall.loginEmail}; path=/`;
          document.cookie = `loginPassword=${dataApiCall.loginPassword}; path=/`;
          document.cookie = `sessionGuid=${sessionGuid}; path=/`;
          document.cookie = `globalUserId=${dataApiCall.globalUserID}; path=/`;
          document.cookie = `databaseId=${dataApiCall.databaseID}; path=/`;
          document.cookie = `login2FASecKey=${dataApiCall.login2FASecKey}; path=/`;
          setCrossDomainCookie(
            "login2FaCodeLastUsedUTCDate",
            dataApiCall.login2FaCodeLastUsedUTCDate
          );
          setCrossDomainCookie(
            "loginLastSec2CheckInUTCDate",
            dataApiCall.LoginLastSec2CheckInUTCDate
          );
          setCrossDomainCookie(
            "loginLastPwdUTCDate",
            dataApiCall.loginLastPwdUTCDate
          );
          setCrossDomainCookie(
            "apiKeyExpirationUTCDate",
            dataApiCall.apiKeyExpirationUTCDate
          );

          if (dataApiCall.accessKey && dataApiCall.refreshKey) {
            setCrossDomainCookie("accessKey", dataApiCall.accessKey);
            setCrossDomainCookie("refreshKey", dataApiCall.refreshKey);
          } else if (dataApiCall.apiKey && dataApiCall.sessionId) {
            setCrossDomainCookie("sessionId", dataApiCall.sessionId);
            setCrossDomainCookie("apiKey", dataApiCall.apiKey);
          }

          window.location.href = getSafeRedirectUrl(
            dataApiCall.redirectUrl,
            window.location.origin,
          );
        }
      } catch (error) {
        console.error("Error fetching IP address or making API call:", error);
        setErrorMessage(error);
      }
    };

    fetchData();
  }, [sessionGuid]);

  return (<div>{errorMessage && <Alert severity="error" data-testid="session-management--Alert-0">{errorMessage}</Alert>}</div>);
};

export default SessionManagement;
